module.exports = __webpack_public_path__ + "img/logo.7fdecc34.png";